import { useTranslation } from 'next-i18next'
// Libs
import styled from 'styled-components'
import React, { useContext } from 'react'
import { useRouter } from 'next/router'

// Comps
import { Modal, Props as ModalProps } from './Modal'
import { show, showFinally } from '../../utils'
import { H5, P } from '../Headings'
import { ModalContentWrapper } from './ModalContentWrapper'
import { ModalCloseButton } from './ModalCloseButton'
import { CTA } from '../CTA'
import { NookEvent } from '../../types'
import { FormField } from '../Inputs/FormField'
import { Input } from '../Inputs/Input'
import { useEmailRsvp, EmailRsvpHock } from '../../hooks/emailRsvp'

// Styles
import { emailRSVPEventModalStyles } from './emailRSVPEventModalStyles'

const EventModalContentContainer = styled(ModalContentWrapper)`
  ${emailRSVPEventModalStyles}
`

// Defs
export type rsvpFormData = {
  name?: string
  email?: string
  t_zone?: string
}

interface Props extends ModalProps {
  onClose?: () => void
  onSubmited?: () => void
  emailRsvpHock: EmailRsvpHock
}

export const EmailRSVPEventWaitingListModal: React.FC<Props> = (props) => {
  const { t } = useTranslation('common')

  // Props.
  const { onClose, onSubmited, emailRsvpHock } = props

  // Global State
  const { name, email, setName, setEmail, errors, isLoading } = emailRsvpHock

  // Funcs
  const theOnClose = () => {
    if (onClose) {
      onClose()
    } else {
      console.warn('@EmailRSVPEventWaitingList->onClose: func not set')
    }
  }

  const onSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault()
    onSubmited()
  }

  // ..
  return (
    <Modal close={theOnClose}>
      <EventModalContentContainer>
        <ModalCloseButton onClick={theOnClose} />
        <form onSubmit={onSubmit}>
          {/* Text */}
          <H5 className="header">
            {t(
              `EmailRSVPEventWaitingListModal1797795545`,
              `Join the waiting list for event`,
            )}
          </H5>
          <P>
            {t(
              `EmailRSVPEventWaitingListModal-532645881`,
              `Leave your name and email and we’ll be sure to notify you if more placements to this event open up.`,
            )}
          </P>

          {/* Inputs */}
          <FormField title={t(`Name`, `Name`)} required error={errors?.name}>
            <Input
              placeholder={t(`Your Name`, `Your Name`)}
              value={name}
              onChange={setName}
            />
          </FormField>

          <FormField title={t(`Email`, `Email`)} required error={errors?.email}>
            <Input
              placeholder={t(`your@email.com`, `your@email.com`)}
              value={email}
              onChange={setEmail}
            />
          </FormField>

          {/* Submit through form */}
          <CTA
            type="submit"
            className="submit purple extra-padding"
            disabled={isLoading}>
            {show(isLoading !== true) && (
              <> {t(`Join wait list`, `Join wait list`)}</>
            )}
            {showFinally(isLoading === true) && (
              <>{t(`Please wait`, `Please wait`)}</>
            )}
          </CTA>

          {/* Any other errors */}
          <P className="warning server-error-message">
            {errors?.t_zone || errors?.error}
          </P>
        </form>
      </EventModalContentContainer>
    </Modal>
  )
}
